import { orchestrator } from 'satcheljs';
import { connectOWAConnectedAccountFailed } from 'owa-accounts-service';
import { AccountsEditorState } from '../store/schema/AccountsEditorState';
import setAccountsEditorState from '../mutators/setAccountsEditorState';
import {
    AccountsFeedbackInitSource,
    lazyGetHasShownAddAccountFailureFeedbackDialog,
    showAddAccountFailureFeedbackDialog,
} from 'owa-accounts-feedback';
import { ErrorType } from 'owa-link-account';

orchestrator(connectOWAConnectedAccountFailed, async actionMessage => {
    const { isReconnectFlow } = actionMessage;
    const errorType = ErrorType[<string>actionMessage.errorType];

    if (errorType == ErrorType.UserCancelled && !isReconnectFlow) {
        let getHasShownFeedbackDialog = await lazyGetHasShownAddAccountFailureFeedbackDialog.import();

        if (!getHasShownFeedbackDialog()) {
            showAddAccountFailureFeedbackDialog(
                AccountsFeedbackInitSource.UserCancelledOAuthClosed
            );
        }
    }

    let accountState;
    if (isReconnectFlow) {
        accountState = AccountsEditorState.ReconnectFailed;
    } else if (errorType == ErrorType.UserCancelled) {
        accountState = AccountsEditorState.AddFailedUserCancelled;
    } else if (errorType == ErrorType.AadAuth) {
        accountState = AccountsEditorState.AddFailedAadAuth;
    } else {
        accountState = AccountsEditorState.AddFailedUnknown;
    }

    setAccountsEditorState(accountState);
});
